function normalizePathPart(pathname: string): string {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === "/" ? "index" : normalized.replace(/^\//, "");
}

function normalizeHashPart(hash: string): string {
  return hash.replace(/^#/, "").replace(/^\/+|\/+$/g, "");
}

export function pageIdFromPathAndHash(pathname: string, hash = ""): string {
  const pathPart = normalizePathPart(pathname);
  const hashPart = normalizeHashPart(hash);
  const rawPageId = hashPart ? `${pathPart}#${hashPart}` : pathPart;

  return rawPageId.replace(/[^\w/-]/g, "_");
}

export function defaultPageId(): string {
  if (typeof window === "undefined") return "index";
  return pageIdFromPathAndHash(window.location.pathname, window.location.hash);
}
